import { useEffect, useState } from "react";
import { useShareContext } from "./BasvuruContext";
import { Card, CardActions, CardContent, colors, Grid, IconButton, Paper, Table, TableBody, TableCell, TableContainer, TableRow, Typography } from "@mui/material";
import { DeleteForever } from "@mui/icons-material";
import KriterTanimlariservice from "../../../service/Ebasvuru/AdayDomain/KriterTanimlariService";
import CustLabel from "../../../components/CustLabel";
import { id } from "date-fns/locale";
import { DisplayformatDate } from "../../../util/DateUtil";

const KriterKomponentList = ({ modulId, kriterKomponent }) => {
    const [kriterler, setKriterler] = useState([]);

    const { modulKriterler, deleteFromDb } = useShareContext();
    const [kriterKomponentList, setKriterKomponentList] = useState([]);


    useEffect(() => {
        // setLoading(true);

        if (modulId) {

            KriterTanimlariservice.fullGet({ filter: { modulId } }).then((res) => {
                //   setLoading(false);

                if (res && res.isSuccess) {
                    const sortedKriterler = [...res.resultObject].sort((a, b) => a.siralama - b.siralama);
                    setKriterler(sortedKriterler);
                }
            });
        }
    }, [modulId]);

    useEffect(() => {
        let data = modulKriterler.filter((item) =>
            Number(item.modulId) === Number(modulId) &&
            Number(item.kriterKomponent) === Number(kriterKomponent));

        if (data)
            setKriterKomponentList(data[0]?.komponentKriterler);

    }, [modulKriterler]);

    const handleDelete = (index, item) => {

        const firstKey = Object.keys(item)[index];

        deleteFromDb({
            refId: item[firstKey]?.refId,
            modulId: modulId,
            komponentId: kriterKomponent,
            kriterId: item[firstKey],
            index: index
        });
    }

    const getLabel = (key) => {
        const data = kriterler.filter(r => Number(r.id) === Number(key));
        return data[0]?.display;
    }

    const getValue = (data, id) => {

        const dateValue = DisplayformatDate(data[id]?.value) ?? data[id]?.value;

        return data[id]?.text ?? dateValue;
    }

    const getKriterLabel = (data, kriter) => {
        if (data[kriter.id]?.kriterGrupAdi) {
            return data[kriter.id]?.kriterGrupAdi
        }
        return kriter?.display;
    }


    const GroupDisplay = (valueObject) => {
        const groupItem = Object.values(valueObject).find(item => item.isGroup === true);

        if (!groupItem) return <></>;

        return (
            <Typography variant="body2" color="gray">
                {groupItem?.kriterGrupAdi} - {groupItem?.text}
            </Typography>
        );
    };


    return (

        <Grid container spacing={2} sx={{ pt: 0 }}>
            {kriterKomponentList?.map((item, index) => (
                <Grid item xs={12} sm={6} md={4} key={index}>
                    <Card variant="outlined">
                        <CardActions sx={{ position: 'relative', backgroundColor: "text.menu", height: '40px' }}>
                            {GroupDisplay(item)}
                            <IconButton
                                onClick={() => handleDelete(index, item)}  // Close button logic
                                sx={{
                                    position: 'absolute',
                                    top: 0,
                                    right: 8,  // Move the button to the right
                                    color: 'danger',  // Update to an appropriate color if needed
                                    zIndex: 1,
                                }}
                            >
                                <DeleteForever color="danger" />
                            </IconButton>
                        </CardActions>
                        <CardContent>
                            <TableContainer
                                component={Paper}
                                sx={{
                                    minHeight: '15vh', // Vertical scrolling limit
                                    maxHeight: '15vh', // Vertical scrolling limit
                                    maxWidth: '100%', // Horizontal scrolling limit (optional)
                                    overflowY: 'auto', // Enable vertical scrolling
                                    overflowX: 'auto', // Enable horizontal scrolling
                                }}
                            >
                                <Table stickyHeader aria-label="sticky table" sx={{ tableLayout: 'fixed' }}>
                                    <TableBody>
                                        {kriterler.map((kriter) => {
                                            const value = getValue(item, kriter.id);
                                            return (
                                                value && (
                                                    <TableRow key={kriter.id}>
                                                        <TableCell
                                                            sx={{
                                                                padding: '0px 3px 0px 13px',
                                                                color: colors.blue[900],
                                                                backgroundColor: colors.grey[50],
                                                                whiteSpace: 'normal',
                                                                border: '1px dot #ccc',
                                                                borderBottom: '0.5px dot  #ccc',
                                                            }}
                                                        >
                                                            {getKriterLabel(item, kriter)}
                                                        </TableCell>
                                                        <TableCell
                                                            sx={{
                                                                padding: '5px 10px',
                                                                whiteSpace: 'normal',
                                                                border: '1px dot #ccc',
                                                                borderBottom: '0.5px dot  #ccc',
                                                            }}
                                                        >
                                                            {value}
                                                        </TableCell>
                                                    </TableRow>
                                                )
                                            );
                                        })}
                                    </TableBody>

                                </Table>
                            </TableContainer>


                        </CardContent>
                    </Card>
                </Grid>
            ))}
        </Grid>

    );
}

export default KriterKomponentList;